/**
 * THIS FILE IS AUTO-GENERATED
 * DON'T MAKE CHANGES HERE
 */
import { compareDependencies } from './dependenciesCompare.generated';
import { compareNaturalDependencies } from './dependenciesCompareNatural.generated';
import { matrixDependencies } from './dependenciesMatrix.generated';
import { typedDependencies } from './dependenciesTyped.generated';
import { createSort } from '../../factoriesAny.js';
export var sortDependencies = {
  compareDependencies: compareDependencies,
  compareNaturalDependencies: compareNaturalDependencies,
  matrixDependencies: matrixDependencies,
  typedDependencies: typedDependencies,
  createSort: createSort
};


//////////////////
// WEBPACK FOOTER
// ./~/mathjs/es/entry/dependenciesAny/dependenciesSort.generated.js
// module id = 1517
// module chunks = 0